import { getDefaultFeaturePolicySnapshot } from '@/config/featurePolicyConfig';

function clone(value) {
    return JSON.parse(JSON.stringify(value));
}

export function createPhaseAPolicyFixture() {
    return clone(getDefaultFeaturePolicySnapshot());
}

export const PHASE_A_POLICY_FIXTURE = Object.freeze(createPhaseAPolicyFixture());
